<template>
  <!-- Contador do chat com clientes, separado do sino: conta só mensagens de chat não lidas
       (inbox + WebSocket do store, iniciado com a sessão — ver store/plugin.js). O sino não
       recebe avisos de chat (CHAT_STAFF_NOTICE_ENABLED desligado no chat-service). -->
  <b-nav-item
    v-if="$can(readAction, resource)"
    v-b-tooltip.hover.bottom
    class="mr-25"
    :to="{ name: 'customer-chat' }"
    title="Chat com clientes"
    :aria-label="ariaLabel"
  >
    <feather-icon
      :badge="unreadBadge"
      badge-classes="bg-danger"
      class="text-body"
      icon="MessageCircleIcon"
      size="21"
    />
  </b-nav-item>
</template>

<script>
import { BNavItem, VBTooltip } from 'bootstrap-vue'
import { mapGetters } from 'vuex'
import { CUSTOMER_CHAT_RESOURCE, READ_ACTION } from '@/constants/resources'
import { TOTAL_UNREAD, TOTAL_UNREAD_BADGE } from '../store/types'

export default {
  components: { BNavItem },
  directives: { 'b-tooltip': VBTooltip },
  data() {
    return {
      resource: CUSTOMER_CHAT_RESOURCE,
      readAction: READ_ACTION,
    }
  },
  computed: {
    ...mapGetters({
      unread: TOTAL_UNREAD,
      unreadBadge: TOTAL_UNREAD_BADGE,
    }),
    ariaLabel() {
      if (!this.unread) return 'Chat com clientes'
      return this.unread === 1
        ? 'Chat com clientes, 1 mensagem não lida'
        : `Chat com clientes, ${this.unread} mensagens não lidas`
    },
  },
}
</script>
